import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import '@style/counter.css';
import { Page, CustomerInfo, Loading } from '@components';
import IsAmount from './components/IsAmount';
import IsCollateral from './components/IsCollateral';
import Notice from '@components/Layout/Notice';
import Complete from '@components/Complete/Complete';
import DeclareModal from './components/DeclareModal';
import TransFlagModal from '@components/Layout/TransFlagModal';
const TrialBalance = () => {
    const [isAmount, setIsAmount] = useState(true);
    const {
        TrialBalanceStore: {
            collateralUIs,
            collateralStockUIs,
            trialBalanceComplete,
            isLoading,
            loadingFailed,
            msg,
            transFlagModalVisible,
            closeTransFlagModal,
            TransMsg,
        },
        AuthStore: { borrowingAmount },
    } = useStore();
    const navigate = useNavigate();
    useEffect(() => {
        if (trialBalanceComplete) {
            setTimeout(() => {
                navigate(0);
            }, 3000);
        }
    }, [trialBalanceComplete]);
    let rate = 0;
    const sum = collateralStockUIs.reduce(
        (preVal, curVal) =>
            preVal + curVal.repayStockQty * 1000 * curVal.closePrice,
        0
    );
    const marketValTotal = collateralUIs.reduce(
        (preVal, curVal) => preVal + curVal.marketVal,
        0
    );
    rate = ((sum + marketValTotal) / borrowingAmount) * 100;

    return (
        <Page>
            <div className=" container">
                <CustomerInfo title="借款維持率試算" />
                <div className="card  wow fadeInDown">
                    {isLoading ? (
                        <Loading isLoading={isLoading} />
                    ) : !trialBalanceComplete ? (
                        <div>
                            <div className="card-body tab-content">
                                <h3 className="title fw-bolder ">
                                    設定試算條件
                                </h3>
                                <div
                                    className={`switch-menu  rounded-pill overflow-hidden mw-100 ${
                                        isAmount ? '' : 'mb-5'
                                    }`}
                                >
                                    <ul className="nav">
                                        <li
                                            className={`rounded-pill ${
                                                isAmount ? 'active' : ''
                                            }`}
                                            onClick={() => {
                                                setIsAmount(true);
                                            }}
                                        >
                                            <a>
                                                <span className="mo-h36">
                                                    補繳
                                                </span>
                                                本金與維持率試算
                                            </a>
                                        </li>
                                        <li
                                            className={`rounded-pill ${
                                                isAmount ? '' : 'active'
                                            }`}
                                            onClick={() => {
                                                setIsAmount(false);
                                            }}
                                        >
                                            <a>擔保品試算</a>
                                        </li>
                                    </ul>
                                </div>
                                {isAmount ? (
                                    <IsAmount />
                                ) : (
                                    <IsCollateral rate={rate} />
                                )}
                            </div>
                            <Notice>
                                {isAmount ? (
                                    <div>
                                        <li>
                                            現金還款金額試算僅供參考，實際追繳金額以結帳資料為準。
                                        </li>
                                        <li>
                                            目標維持率試算僅供參考，實際維持率以結帳資料為準。
                                        </li>
                                        <li>
                                            維持率=(擔保品市值+補繳擔保品市值)/已借總金額
                                            *100%。
                                        </li>
                                        <li>
                                            整戶擔保維持率低於 130%
                                            時，本公司會通知您補繳借款差額，請於通知後二個營業日內完成補繳。
                                        </li>
                                        <li>
                                            未於二個營業日內補繳且整戶擔保維持率仍未達
                                            130%
                                            以上者，本公司將依規定於第三個營業日起處分其
                                            <span className="text-decoration-underline">
                                                整戶之所有擔保品
                                            </span>
                                            。
                                        </li>
                                        <li>
                                            營業日9:00~15:00申請，當日新增擔保品。
                                        </li>
                                    </div>
                                ) : (
                                    <div>
                                        <li>
                                            目標維持率試算僅供參考，實際維持率以結帳資料為準。
                                        </li>
                                        <li>
                                            維持率=(擔保品市值+補繳擔保品市值)/已借總金額*100%。
                                        </li>
                                        <li>
                                            整戶擔保維持率低於130%時，本公司會通知您補繳借款差額，請於通知後二個營業日內完成補繳。
                                        </li>
                                        <li>
                                            未於二個營業日內補繳且整戶擔保維持率仍未達130%以上者，本公司將依規定於第三個營業日起處分其
                                            <span className="text-decoration-underline">
                                                整戶之所有擔保品
                                            </span>
                                            。
                                        </li>
                                        <li>
                                            營業日9:00~15:00申請，當日新增擔保品。
                                        </li>
                                        <li>
                                            發行公司之董事、監察人、經理人及持股超過股份總額百分之十股東，請臨櫃辦理質權設定。
                                        </li>
                                        <li>
                                            擔保品需完成交割，買進股票於T+2日11點可進行增加擔保品。
                                        </li>
                                    </div>
                                )}
                            </Notice>
                        </div>
                    ) : (
                        <Complete
                            other={'增加'}
                            feature={'擔保品'}
                            remindText={'審核成功後，股票自您庫存中扣除。'}
                            loadingFailed={loadingFailed}
                            msg={msg}
                        />
                    )}
                </div>
                <TransFlagModal
                    visibleHandler={transFlagModalVisible}
                    closeModal={closeTransFlagModal}
                    msg={TransMsg}
                />
                <DeclareModal />
            </div>
        </Page>
    );
};

export default observer(TrialBalance);
